export enum DateIntervalTypes {
  TWENTY_FOUR_HOURS = "TWENTY_FOUR_HOURS",
  THREE_DAYS = "THREE_DAYS",
  ONE_WEEK = "ONE_WEEK",
  TWO_WEEKS = "TWO_WEEKS",
  ONE_MONTH = "ONE_MONTH",
  TWO_MONTHS = "TWO_MONTHS"
}